import * as yup from 'yup';

export const productValidationSchema = yup.object({
  name: yup
    .string('Enter product name')
    .min(3, 'Product Name should be of minimum 3 characters length')
    .required('Product name is required'),
  imageSrc: yup
    .string('Enter image link')
    .min(10, 'Image Link should be of minimum 10 characters length')
    .required('Image Link is required'),
  description: yup
    .string('Enter description')
    .min(20, 'Description should be of minimum 20 characters length')
    .required('Description is required'),
  price: yup
    .number('Enter price')
    .min(1, 'Price should be more than $1')
    .required('Price is required'),
});

export const orderValidationSchema = yup.object({
  first_name: yup
    .string('Enter your First Name')
    .min(3, 'Name should be of minimum 3 characters length')
    .required('Name is required'),
  last_name: yup
    .string('Enter your Last Name')
    .min(3, 'Name should be of minimum 3 characters length')
    .required('Name is required'),
  email: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  address: yup
    .string('Enter address')
    .min(10, 'Address should be of minimum 10 characters length')
    .required('Address is required'),
});
